import { SvgIcon, SvgIconProps } from '@mui/material';
/* eslint-disable-next-line */
export interface CcfOfflineIconProps extends SvgIconProps {}
/**
 * component used to display logput icon in agent state panel
 * @param props - CcfLogoutIconProps
 * @example - <CcfLogoutIcon />
 * @returns SVG of logout icon
 */
export function CcfOfflineIcon(props: CcfOfflineIconProps) {
  return (
    <SvgIcon width="13" height="14" viewBox="0 0 13 14" {...props}>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 6.5C12 9.81371 9.31371 12.5 6 12.5C2.68629 12.5 0 9.81371 0 6.5C0 3.18629 2.68629 0.5 6 0.5C9.31371 0.5 12 3.18629 12 6.5ZM3.03015 3.53017C3.26447 3.29585 3.64437 3.29585 3.87868 3.53017L6 5.65148L8.12132 3.53016C8.35564 3.29584 8.73554 3.29584 8.96985 3.53016C9.20417 3.76447 9.20417 4.14437 8.96985 4.37868L6.84852 6.50001L8.96985 8.62134C9.20416 8.85565 9.20416 9.23555 8.96985 9.46986C8.73553 9.70418 8.35564 9.70418 8.12132 9.46986L6 7.34854L3.87868 9.46985C3.64437 9.70417 3.26447 9.70417 3.03015 9.46985C2.79584 9.23554 2.79584 8.85564 3.03015 8.62132L5.15147 6.50001L3.03015 4.3787C2.79584 4.14438 2.79584 3.76448 3.03015 3.53017Z"
        fill="#A5A7AA"
      />
    </SvgIcon>
  );
}

export default CcfOfflineIcon;
